import React, { useEffect, useState } from 'react';

import Header from './header'
import style from  '../scss/Home.scss'


function Home(props) {
    return (
        <>
            <Header></Header>
            <div className="box1">
                <div className="container">
                <section>
                    <h1>专注于企业礼品定制设计</h1>
                    <p>我们是一家以营销、策划、创意、制作为一体的消费礼赠品 <br />
                    研究、创意礼品开发与销售集成的商务公司</p>
                    <a className="btn">了解更多</a>
                </section>
                </div>
            </div>


            <div className="box2">
                <div className="title">
                    <h1>我们是谁</h1>
                    <span></span>
                </div>

                <section>
                    <div>
                        <div>
                        <h2>关于博睿</h2>
                        <p>博睿成立于1997年，是一家以营销、策划、创意、制作为一体的消费礼  <br/>
                            赠品研究、创意礼品开发与销售集成的商务公司。</p>
                        <p>企业整合服务范围涉及平面设计、创意礼品开发、商务礼品采购及制作、  <br/>
                            消费市场研究、配套物流运输等领域，为客户提供全方位的礼赠品市场 <br/>
                            服务。</p>
                         <p>主要服务的行业有金融保险业、汽车业、 IT及通讯业、快速消费品等多 <br/>
                             个行业，在西北、西南、华南、东北等地有独立的仓储以及联合物流储 <br/>
                             运公司，分销网络覆盖全国市场。</p>
                             </div>
                    </div>
                    <div></div>
                </section>
            </div>

            <div className="box3">
                <div className="title">
                    <h1>我们能做什么</h1>
                    <span></span>
                </div>

                <section>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <span>平面设计</span>
                    <span>创意礼品开发</span>
                    <span className="box3-s3">商务礼品采购及制作</span>
                    <span>消费市场研究 </span>
                    <span>配套物流运输</span>
                </section>
            </div>

            <div className="box4">

            </div>

            <div className="box5">
            <div className="title">
                    <h1>服务过的客户</h1>
                    <span></span>
                </div>
                
                <div className="icons">
                <img src={require('../imgs/icons/01.png')} alt=""/>
                <img src={require('../imgs/icons/02.png')} alt=""/>
                <img src={require('../imgs/icons/03.png')} alt=""/>
                <img src={require('../imgs/icons/04.png')} alt=""/>
                <img src={require('../imgs/icons/05.png')} alt=""/>
                <img src={require('../imgs/icons/06.png')} alt=""/>
                <img src={require('../imgs/icons/07.png')} alt=""/>
                <img src={require('../imgs/icons/08.png')} alt=""/>
                <img src={require('../imgs/icons/09.png')} alt=""/>
                <img src={require('../imgs/icons/10.png')} alt=""/>
                <img src={require('../imgs/icons/11.png')} alt=""/>
                <img src={require('../imgs/icons/12.png')} alt=""/>
                <img src={require('../imgs/icons/13.png')} alt=""/>
                <img src={require('../imgs/icons/14.png')} alt=""/>
                <img src={require('../imgs/icons/15.png')} alt=""/>
                </div>
            </div>

        <div className="box6">
            <div className="title">
                    <h1>样品展示</h1>
                    <span></span>
            </div>

            <div className="icons">
                <img src={require('../imgs/icon2/01.png')} alt=""/>
                <img src={require('../imgs/icon2/02.png')} alt=""/>
                <img src={require('../imgs/icon2/03.png')} alt=""/>
                <img src={require('../imgs/icon2/04.png')} alt=""/>
            </div>
        </div>
        
        <div className="box7">
            <div className="title">
                    <h1>商务案例</h1>
                    <span></span>
            </div>
            <section>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </section>
        </div>

  
        </>
    )
}



export default Home






